
const FIELD_STAKEHOLDER_FIRST_NAME = "firstName";

const FIELD_STAKEHOLDER_LAST_NAME = "lastName";

const FIELD_STAKEHOLDER_TITLE = "customTitle";

const FIELD_STAKEHOLDER_PARTY = 'party';

const FIELD_STAKEHOLDER_PRIMARY_PHONE = "primaryPhone";

const FIELD_STAKEHOLDER_PRIMARY_EMAIL = "primaryEmail";

const FIELD_STAKEHOLDER_TWITTER_USERNAME = "twitterProfileUrl";

const FIELD_STAKEHOLDER_TWITTER = "twitterProfile";

const FIELD_SDG_NAME = "sdgName";

// Same Regex as we use for Aero Phone validation
const PHONE_REGEX_RULE =
    "regex:^[\\s]*?(?:(?:(?:\\+)?1[-.\\s]?)?)\\(?([0-9]{3})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})[\\s]*?$";

const MISSING_STAKEHOLDER_FIRST_NAME_MESSAGE =
    "Please enter a First Name for this recipient.";

const MISSING_STAKEHOLDER_LAST_NAME_MESSAGE =
    "Please enter a Last Name for this recipient.";

const MISSING_STAKEHOLDER_TITLE_MESSAGE =
    "Please enter a Title for this recipient.";

const MISSING_STAKEHOLDER_PARTY_MESSAGE =
    "Please select a party for this recipient.";

const MISSING_SDG_NAME_MESSAGE =
    "Please enter a name for your special delivery group.";

const INVALID_PHONE_MESSAGE = "Please enter a valid phone number.";

const INVALID_EMAIL_MESSAGE = "Please enter a valid email address.";

const INVALID_TWITTER_MESSAGE = "Please enter a valid email address.";

const INVALID_TWITTER_USERNAME_MESSAGE = "Please enter a valid twitter username.";

const IS_VALID_TWITTER_USERNAME = 'isValidTwitterUsername';

const RULES = [
    {
        name: FIELD_STAKEHOLDER_FIRST_NAME,
        validationRules: {
            required: MISSING_STAKEHOLDER_FIRST_NAME_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_LAST_NAME,
        validationRules: {
            required: MISSING_STAKEHOLDER_LAST_NAME_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_TITLE,
        validationRules: {
            required: MISSING_STAKEHOLDER_TITLE_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_PARTY,
        validationRules: {
            required: MISSING_STAKEHOLDER_PARTY_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_PRIMARY_PHONE,
        validationRules: {
            [PHONE_REGEX_RULE]: INVALID_PHONE_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_PRIMARY_EMAIL,
        validationRules: {
            email: INVALID_EMAIL_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_TWITTER_USERNAME,
        validationRules: {
            [IS_VALID_TWITTER_USERNAME]: INVALID_TWITTER_USERNAME_MESSAGE
        }
    },

    {
        name: FIELD_STAKEHOLDER_TWITTER,
        validationRules: {
            email: INVALID_TWITTER_MESSAGE
        }
    },

    {
        name: FIELD_SDG_NAME,
        validationRules: {
            required: MISSING_SDG_NAME_MESSAGE
        }
    },
];

export {
    RULES,
    FIELD_STAKEHOLDER_FIRST_NAME,
    FIELD_STAKEHOLDER_LAST_NAME,
    FIELD_STAKEHOLDER_TITLE,
    FIELD_STAKEHOLDER_PRIMARY_PHONE,
    FIELD_STAKEHOLDER_PRIMARY_EMAIL,
    FIELD_STAKEHOLDER_TWITTER_USERNAME,
    FIELD_SDG_NAME,
    INVALID_EMAIL_MESSAGE,
    INVALID_PHONE_MESSAGE,
    PHONE_REGEX_RULE,
    FIELD_STAKEHOLDER_TWITTER,
    INVALID_TWITTER_MESSAGE,
    FIELD_STAKEHOLDER_PARTY,
    MISSING_STAKEHOLDER_PARTY_MESSAGE,
    INVALID_TWITTER_USERNAME_MESSAGE,
    IS_VALID_TWITTER_USERNAME
};
